export default __webpack_public_path__ + "static/media/lv.197ea141.jpg";